import { HandHelping } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import useSWR from 'swr'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Skeleton } from '@/components/ui/skeleton'
import { Dashboard } from '@/containers/Dashboard'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'
import { DashboardStats } from '@/interfaces/DashboardStats'
import { Settings } from '@/interfaces/Settings'

const DashboardSkeleton = () => (
  <div className="mx-auto w-full max-w-[1280px] space-y-6">
    <div className="space-y-2 pb-1">
      <Skeleton className="h-7 w-32" />
      <Skeleton className="h-4 w-56" />
    </div>
    <Skeleton className="h-24 w-full rounded-lg" />
    <Skeleton className="h-[360px] w-full rounded-lg" />
  </div>
)

export default function DashboardPage() {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'dashboard',
  })

  const { data, isLoading, error } = useSWR<DashboardStats>(`/api/v1/dashboard-stats`, apiFetcher)
  const { data: settings } = useSWR<Settings>('/api/v2/settings', apiFetcher)

  useSetPageHeader({ newButton: 'invoice' })

  return (
    <>
      <title>{t('title')}</title>

      {settings && settings.participantId === null && (
        <Alert className="mx-auto mb-6 max-w-[1280px]" variant="help">
          <HandHelping />
          <AlertTitle>Vítejte v invo.space!</AlertTitle>
          <AlertDescription>
            <Link to="/settings/invoicing" className="underline text-accent-foreground">
              Pro vystavení prvního dokladu bude potřeba zadat své fakturační údaje.
            </Link>
          </AlertDescription>
        </Alert>
      )}

      {isLoading && <DashboardSkeleton />}
      {error && !data && (
        <p className="mx-auto max-w-[1280px] text-sm text-muted-foreground">Přehled se nepodařilo načíst. Zkuste stránku obnovit.</p>
      )}
      {data && <Dashboard data={data} currency={data.receivedThisYear?.currency ?? 'CZK'} />}
    </>
  )
}
